(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-related"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-related-carousel')) {
    customElements.define('product-related-carousel', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.handleCardClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleCardClick);
      }

      handleCardClick = (event) => {
        if (!window.matchMedia('(max-width: 749px)').matches || event.detail === 0) return;

        const card = event.target.closest('.product-related__card');
        if (!card || !this.contains(card)) return;

        const trackLeft = this.getBoundingClientRect().left;
        const cardLeft = card.getBoundingClientRect().left;
        if (Math.abs(cardLeft - trackLeft) <= 2) return;

        event.preventDefault();
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.scrollTo({
          left: this.scrollLeft + cardLeft - trackLeft,
          behavior: reducedMotion ? 'auto' : 'smooth'
        });
      };
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  if (!customElements.get('product-gallery')) {
    customElements.define('product-gallery', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-product-slide]')];
        this.thumbnails = [...this.querySelectorAll('[data-gallery-thumbnail]')];
        this.current = 0;
        this.startX = null;
        this.slides.forEach((slide) => this.initialiseVideo(slide));
        this.querySelector('[data-gallery-previous]')?.addEventListener('click', () => this.show(this.current - 1));
        this.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.show(this.current + 1));
        this.thumbnails.forEach((thumbnail) => thumbnail.addEventListener('click', () => this.show(Number(thumbnail.dataset.index))));
        const stage = this.querySelector('.product-gallery__stage');
        stage?.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') this.show(this.current - 1);
          if (event.key === 'ArrowRight') this.show(this.current + 1);
        });
        stage?.addEventListener('pointerdown', (event) => { this.startX = event.clientX; });
        stage?.addEventListener('pointerup', (event) => {
          if (this.startX === null) return;
          const distance = event.clientX - this.startX;
          this.startX = null;
          if (Math.abs(distance) >= 45) this.show(this.current + (distance < 0 ? 1 : -1));
        });
        this.playVideo(this.slides[this.current]);
        this.queueGalleryImages();
      }
      queueGalleryImages() {
        const preload = () => {
          this.querySelectorAll('[data-product-slide] img.product-gallery__media').forEach((image) => {
            if (image.complete && image.naturalWidth > 0) return;
            image.fetchPriority = 'low';
            image.loading = 'eager';
            image.decode?.().catch(() => {});
          });
        };
        const schedule = () => {
          if ('requestIdleCallback' in window) {
            window.requestIdleCallback(preload, { timeout: 1200 });
          } else {
            window.setTimeout(preload, 0);
          }
        };
        if (document.readyState === 'complete') {
          schedule();
        } else {
          window.addEventListener('load', schedule, { once: true });
        }
      }
      initialiseVideo(slide) {
        const video = slide.querySelector('video');
        const playButton = slide.querySelector('[data-video-play]');
        if (!video) return;

        video.muted = true;
        video.playsInline = true;
        video.loop = true;
        if (video.matches('[data-transparent-video]')) {
          const fallback = slide.querySelector('[data-transparent-fallback]');
          const staticImage = slide.querySelector('.product-gallery__transparent-static');
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          const safari = /Safari\//.test(navigator.userAgent) && !/(Chrome|Chromium|CriOS|Edg|OPR)\//.test(navigator.userAgent);
          const appleMobile = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
          const showFallback = () => {
            video.pause();
            video.hidden = true;
            if (fallback?.dataset.src && !fallback.src) fallback.src = fallback.dataset.src;
            if (fallback) fallback.hidden = false;
          };
          if (reducedMotion && staticImage) {
            video.pause();
            video.hidden = true;
            staticImage.hidden = false;
          } else if (video.dataset.safariSrc) {
            video.addEventListener('error', showFallback, { once: true });
            if (safari || appleMobile) {
              if (video.canPlayType('video/mp4; codecs="hvc1"')) {
                video.src = video.dataset.safariSrc;
              } else {
                showFallback();
              }
            } else if (video.canPlayType('video/webm; codecs="vp9"')) {
              video.src = video.dataset.webmSrc;
            } else {
              showFallback();
            }
          } else if (safari || !video.canPlayType('video/webm; codecs="vp9"')) {
            showFallback();
          } else {
            video.addEventListener('error', showFallback, { once: true });
          }
          return;
        }
        if (!playButton) return;
        const syncButton = () => { playButton.hidden = !video.paused && !video.ended; };
        video.addEventListener('play', syncButton);
        video.addEventListener('pause', syncButton);
        video.addEventListener('ended', syncButton);
        video.addEventListener('click', () => { if (!video.paused) video.pause(); });
        playButton.addEventListener('click', () => video.play().catch(syncButton));
        syncButton();
      }
      playVideo(slide) {
        const video = slide?.querySelector('video');
        if (!video || video.hidden) return;
        video.muted = true;
        video.play().catch(() => {
          const playButton = slide.querySelector('[data-video-play]');
          if (playButton) playButton.hidden = false;
        });
      }
      show(index) {
        if (this.slides.length < 2) return;
        this.current = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === this.current;
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
          if (!active) slide.querySelector('video')?.pause();
        });
        this.thumbnails.forEach((thumbnail, thumbnailIndex) => {
          const active = thumbnailIndex === this.current;
          thumbnail.classList.toggle('is-active', active);
          thumbnail.setAttribute('aria-selected', String(active));
          if (active) thumbnail.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        });
        const counter = this.querySelector('[data-gallery-current]');
        if (counter) counter.textContent = String(this.current + 1).padStart(2, '0');
        this.playVideo(this.slides[this.current]);
      }
    });
  }
  if (!customElements.get('product-purchase')) {
    customElements.define('product-purchase', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.button = this.querySelector('.product-main__add');
        this.status = this.querySelector('[data-purchase-status]');
        this.querySelector('select[name="id"]')?.addEventListener('change', (event) => {
          const option = event.target.selectedOptions[0];
          this.closest('.product-main')?.querySelectorAll('[data-product-price]').forEach((price) => { price.textContent = option.dataset.price; });
          const label = this.button?.querySelector('[data-add-label]');
          const available = option.dataset.available === 'true';
          if (this.button) this.button.disabled = !available;
          if (label) label.textContent = available ? this.dataset.availableLabel : this.dataset.soldOutLabel;
          this.hideStatus();
        });
        this.form?.addEventListener('submit', (event) => this.addToCart(event));
      }
      hideStatus() {
        if (!this.status) return;
        this.status.hidden = true;
        this.status.textContent = '';
        delete this.status.dataset.error;
      }
      showStatus(message, isError = false) {
        if (!this.status) return;
        this.status.textContent = message;
        this.status.hidden = false;
        this.status.dataset.error = String(isError);
      }
      updateHeaderCart(itemCount) {
        const cartLink = document.querySelector('.site-header__cart');
        if (!cartLink) return;
        let count = cartLink.querySelector('.site-header__cart-count');
        if (!count) {
          count = document.createElement('span');
          count.className = 'site-header__cart-count';
          cartLink.append(count);
        }
        count.textContent = String(itemCount);
        count.hidden = itemCount === 0;
        cartLink.setAttribute('aria-label', `${this.dataset.cartLabel}, ${itemCount} ${this.dataset.itemsLabel}`);
      }
      async addToCart(event) {
        if (this.dataset.redirectToCart === 'true') {
          this.button?.classList.add('is-adding');
          return;
        }
        event.preventDefault();
        if (!this.form || !this.button || this.button.disabled) return;

        this.hideStatus();
        const animationStartedAt = performance.now();
        this.button.classList.add('is-adding');
        this.button.disabled = true;
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(this.form),
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || this.dataset.errorLabel);

          const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
          if (!cartResponse.ok) throw new Error(this.dataset.errorLabel);
          const cart = await cartResponse.json();
          this.updateHeaderCart(cart.item_count);
          this.showStatus(this.dataset.addedLabel);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, item: result } }));
        } catch (error) {
          this.showStatus(error.message || this.dataset.errorLabel, true);
        } finally {
          const animationTimeRemaining = Math.max(0, 720 - (performance.now() - animationStartedAt));
          if (animationTimeRemaining > 0) await new Promise((resolve) => setTimeout(resolve, animationTimeRemaining));
          this.button.classList.remove('is-adding');
          const selected = this.querySelector('select[name="id"]')?.selectedOptions[0];
          this.button.disabled = selected ? selected.dataset.available !== 'true' : false;
        }
      }
    });
  }

  const initialiseProductAccordions = (root = document) => {
    root.querySelectorAll('.product-main__accordion').forEach((details) => {
      if (details.dataset.animatedAccordion === 'true') return;
      const summary = details.querySelector('summary');
      const content = details.querySelector('.product-main__accordion-content');
      if (!summary || !content) return;

      details.dataset.animatedAccordion = 'true';
      let animation;
      summary.addEventListener('click', (event) => {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        event.preventDefault();
        animation?.cancel();
        const opening = !details.open;
        if (opening) details.open = true;

        const contentHeight = content.scrollHeight;
        animation = content.animate(
          opening
            ? [{ height: '0px', opacity: 0 }, { height: `${contentHeight}px`, opacity: 1 }]
            : [{ height: `${contentHeight}px`, opacity: 1 }, { height: '0px', opacity: 0 }],
          { duration: 280, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' },
        );
        animation.onfinish = () => {
          if (!opening) details.open = false;
          animation = undefined;
        };
      });
    });
  };

  initialiseProductAccordions();
  document.addEventListener('shopify:section:load', (event) => initialiseProductAccordions(event.target));

  customElements.define('gallery-enquiry', class extends HTMLElement {
    connectedCallback() {
      this.openButton = this.querySelector('[data-enquiry-open]');
      this.panel = this.querySelector('[data-enquiry-panel]');
      if (!this.openButton || !this.panel) return;

      this.openButton.addEventListener('click', () => {
        this.openButton.hidden = true;
        this.panel.classList.remove('is-stowed');
      });

      this.fillArtwork();
    }

    // The country button ships 46px tall next to a 48px input, capped by its own
    // max-height. Outside CSS can't reach into the shadow root, and the app's
    // styles are adopted stylesheets that outrank an injected rule at equal
    // specificity, so this selector is deliberately one level more specific.
    matchCountryButtonHeight(shadow) {
      if (shadow.querySelector('#gallery-enquiry-style')) return;
      const style = document.createElement('style');
      style.id = 'gallery-enquiry-style';
      style.textContent =
        '.phone-country-selector [class*="selectContainer"],' +
        '.phone-country-selector button[class*="selectToggle"]' +
        '{height:48px!important;max-height:48px!important;}' +
        // Match the gradient, uppercase CTA used everywhere else on the page.
        'form button[type="submit"]{background:linear-gradient(90deg,#ffb806 0%,#f29010 28%,' +
        '#ee5b0e 58%,#d8351a 82%,#9e1f05 100%)!important;text-transform:uppercase!important;' +
        'letter-spacing:0.84px!important;font-weight:500!important;font-size:14px!important;}';
      shadow.appendChild(style);
    }

    // The Forms app has no dynamic field values, so the artwork name is written
    // into its "Artwork" field and that field is hidden from the customer. The
    // widget uses an open shadow root and renders asynchronously, hence polling.
    fillArtwork() {
      const artwork = this.dataset.artwork;
      if (!artwork) return;

      let attempts = 0;
      const timer = setInterval(() => {
        attempts += 1;
        if (attempts > 40) { clearInterval(timer); return; }

        try {
          const embed = this.querySelector('shopify-forms-embed');
          const shadow = embed && embed.shadowRoot;
          if (!shadow) return;

          this.matchCountryButtonHeight(shadow);

          const label = [...shadow.querySelectorAll('label[id^="label-"]')]
            .find((node) => node.id.toLowerCase().indexOf('artwork') !== -1);
          if (!label) return;

          const container = label.parentElement;
          const input = container && container.querySelector('input, textarea');
          if (!input) return;

          clearInterval(timer);

          const proto = input instanceof HTMLTextAreaElement ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
          Object.getOwnPropertyDescriptor(proto, 'value').set.call(input, artwork);
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));

          container.style.cssText = 'position:absolute;opacity:0;pointer-events:none;width:1px;height:1px;overflow:hidden;';
          container.setAttribute('aria-hidden', 'true');
        } catch (error) {
          clearInterval(timer);
        }
      }, 500);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["special-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('special-product-gallery')) {
    customElements.define('special-product-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialised === 'true') return;
        this.dataset.initialised = 'true';
        this.slides = [...this.querySelectorAll('[data-special-slide]')];
        this.thumbnails = [...this.querySelectorAll('[data-special-thumbnail]')];
        this.thumbnails.forEach((thumbnail) => thumbnail.addEventListener('click', () => this.show(Number(thumbnail.dataset.index))));
        this.querySelectorAll('video').forEach((video) => {
          video.autoplay = true;
          video.controls = false;
          video.defaultMuted = true;
          video.loop = true;
          video.muted = true;
          video.playsInline = true;
          if (!video.matches('[data-transparent-video]')) return;

          const media = video.closest('[data-transparent-media]');
          const fallback = media?.querySelector('[data-transparent-fallback]');
          const staticImage = media?.querySelector('.special-piece__transparent-static');
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          const safari = /Safari\//.test(navigator.userAgent) && !/(Chrome|Chromium|CriOS|Edg|OPR)\//.test(navigator.userAgent);
          const appleMobile = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
          const source = video.querySelector('source[data-safari-src]');
          const showFallback = () => {
            video.pause();
            video.hidden = true;
            if (fallback?.dataset.src && !fallback.src) fallback.src = fallback.dataset.src;
            if (fallback) fallback.hidden = false;
          };

          if (reducedMotion && staticImage) {
            video.pause();
            video.hidden = true;
            staticImage.hidden = false;
          } else {
            video.addEventListener('error', showFallback, { once: true });
            if (safari || appleMobile) {
              if (video.canPlayType('video/mp4; codecs="hvc1"')) video.src = source.dataset.safariSrc;
              else showFallback();
            } else if (video.canPlayType('video/webm; codecs="vp9"')) {
              video.src = source.dataset.webmSrc;
            } else {
              showFallback();
            }
          }
        });
        this.show(Math.max(0, this.thumbnails.findIndex((thumbnail) => thumbnail.classList.contains('is-active'))));
        if ('IntersectionObserver' in window) {
          this.preloadObserver = new IntersectionObserver((entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.preloadObserver.disconnect();
            this.preloadImages();
          }, { rootMargin: '400px 0px' });
          this.preloadObserver.observe(this);
        } else {
          this.preloadImages();
        }
      }

      disconnectedCallback() {
        this.preloadObserver?.disconnect();
      }

      async preloadImages() {
        if (this.dataset.galleryImages) return;
        this.dataset.galleryImages = 'loading';
        const images = [...this.querySelectorAll('img[loading="lazy"]')];
        images.forEach((image) => { image.loading = 'eager'; });
        await Promise.allSettled(images.map((image) => image.decode()));
        this.dataset.galleryImages = 'ready';
      }

      show(index) {
        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === index;
          slide.hidden = !active;
          const video = slide.querySelector('video');
          if (active && video && !video.hidden) video.play().catch(() => {});
          else video?.pause();
        });
        this.thumbnails.forEach((thumbnail, thumbnailIndex) => {
          const active = thumbnailIndex === index;
          thumbnail.classList.toggle('is-active', active);
          thumbnail.setAttribute('aria-selected', String(active));
        });
      }

    });
  }

  } catch(e) { console.error(e); }
})();
})();
